import { Brand } from '../../components/ui/Icon';

export function AuthAside() {
  return (
    <aside className="auth-aside">
      <Brand />
      <div>
        <h1>
          A casa em ordem.
          <br />O cuidado em <em>primeiro lugar.</em>
        </h1>
        <p>Pessoas, compromissos e recursos no mesmo lugar. A casa decide. O Zeladoria organiza.</p>
      </div>
      <small>Um produto Stavitel · Acesso protegido pelo Phoenix A</small>
    </aside>
  );
}
